export function initializeFilterjob () {
// Blog Artikel Filter
    const jobFilterForm = document.getElementById("jobFilter");
    const jobWrapper = document.getElementById("jobsWrapper");

    if (jobFilterForm && jobWrapper) {
        jobFilterForm.addEventListener('change', () => fetchJob(jobWrapper))
        jobFilterForm.addEventListener('reset', () => fetchJob(jobWrapper))
    }

    async function fetchJob(jobWrapper) {
        //console.log('Blog Ausgabe geht');
        const form = document.getElementById("jobFilter");
        let payload = serialize(form);
        form.classList.add("loading");
        //console.log('payload');
        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: payload,
        })
            .then(response => response.text())
            .then(jobList => {
               // console.log('fetched Job: ')
               // console.log(jobList);
                jobWrapper.innerHTML = jobList;
                form.classList.remove("loading");
                handlePagination("jobPagination");
            })
            .catch(error => console.error('Error fetching jobs:', error));
    }


    function handlePagination(elementId) {
        const pagination = document.getElementById(elementId);
        if (pagination) {
            pagination.addEventListener("click", (e) => {
                e.preventDefault();
                const target = e.target;
                if (target.tagName === 'A') {
                    const page = target.dataset.page;
                    if (page) {
                        // Add page number to the serialized form data
                        const form = document.getElementById("jobFilter");
                        let payload = serialize(form) + "&page=" + page;
                        fetchBlog(blogWrapper, payload); // Assuming fetchBlog can also take payload as an argument
                    }
                }
            });
        }
    }

    handlePagination("jobPagination");

    function serialize(form) {
        let field, s = [];
        if (typeof form == 'object' && form.nodeName == "FORM") {
            let len = form.elements.length;
            for (let i = 0; i < len; i++) {
                field = form.elements[i];
                if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
                    if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                        s.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
                    }
                }
            }
        }
        s.push('action=filter_job'); // Stelle sicher, dass die Aktion hinzugefügt wird
        return s.join('&').replace(/%20/g, '+');
    }

}